import React from 'react';
import { Route, useHistory } from 'react-router-dom';

import { useAuth } from '../../utils/hooks';
import { PRICING_ROUTE } from '../../routes';

interface Props {
  path: string | string[];
  exact: boolean;
  userInfo: any;
  userLoading: boolean;
  withSubscription?: boolean;
  render: Function;
}

const ProtectedRoute: React.FC<Props> = ({
  path,
  exact = false,
  userInfo,
  userLoading,
  withSubscription = true,
  render,
}) => {
  const { isInitialized, isLoading, loginWithRedirect } = useAuth();
  const history = useHistory();

  if (userLoading || !isInitialized || isLoading) {
    return null;
  }

  if (!userInfo && window?.location?.href) {
    loginWithRedirect();
    return null;
  }

  if (!userInfo?.has_subscription && withSubscription) {
    history.replace(PRICING_ROUTE);
    return null;
  }

  return (
    <Route path={path} exact={exact}>
      {render()}
    </Route>
  );
};

export default ProtectedRoute;
